<div *ngFor="let s of sizes" class="invisible {{ s.css + ' ' + (prefix + s.id) }}"></div>
<div *ngIf="assetId$ | async as assetId" class="px-8 widget-bg-color rounded-lg flex flex-col h-full">
  <div class="h-full w-full overflow-y-auto">
    <ng-container *ngIf="combinedAssetRelations$ | async as combinedRelations">
      <ng-container *ngIf="combinedRelations.groupedAssetRelations as groups">
        <mat-accordion multi togglePosition="before" *ngIf="groups.length && assetViewTypeService.getGridSettings('showGridView', gridSettingsKeySuffix)" class="asset-area w-full pb-0">
          <div class="related-assets-group mb-1" *ngFor="let assetGroup of groups; let i = index">
            <mat-expansion-panel *ngIf="assetGroup" [expanded]="i === 0" class="!mb-2">
              <mat-expansion-panel-header collapsedHeight="2.5rem" expandedHeight="2.5rem">
                <mat-panel-title class="font-bold text-lg">{{ relationTypeName(assetGroup.relationshipType) }} ({{ assetGroup.relatedAssets.length }})</mat-panel-title>
              </mat-expansion-panel-header>
              <mat-divider></mat-divider>
              <div class="pt-6 w-full" [ngClass]="showEmptyState ? '!h-[1px]' : 'h-[88%]'">
                <div class="gallery-wrapper" [ngStyle]="{ height: getGalleryHeight(assetGroup.relatedAssets.length) }">
                  <thehubz-asset-gallery-view
                    [configObject]="configObject"
                    [imageObject]="assetGroup.relatedAssets"
                    [imageSplitObject]="assetGroup.splitRelatedAssets"
                    (downloadAsset)="download($event.asset)"
                    [enableAssetDetailsLink]="true"
                    [relationFlag]="true"
                    [gridSettingsKeySuffix]="gridSettingsKeySuffix"
                    [currentSize]="currentSize"
                    (editAssets)="editAssets($event)"
                    class="h-full"
                  ></thehubz-asset-gallery-view>
                </div>
              </div>
            </mat-expansion-panel>
          </div>
        </mat-accordion>
      </ng-container>
      <ng-container *ngIf="combinedRelations.relatedCollections as relatedCollectionList">
        <mat-accordion multi togglePosition="before" *ngIf="relatedCollectionList.length && assetViewTypeService.getGridSettings('showGridView', gridSettingsKeySuffix)" class="asset-area w-full pt-0">
          <mat-expansion-panel [expanded]="!combinedRelations.groupedAssetRelations.length && relatedCollectionList.length" class="!mb-2">
            <mat-expansion-panel-header collapsedHeight="2.5rem" expandedHeight="2.5rem">
              <mat-panel-title class="font-bold text-lg !grow-0" i18n
                >Collections&#160;
                <span *ngIf="collectionListCount">({{ collectionListCount }})</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-divider></mat-divider>
            <div class="pt-6 w-full">
              <div class="gallery-wrapper" [ngStyle]="{ height: getGalleryHeight(relatedCollectionList.length) }">
                <thehubz-collections-list
                  [configObject]="configObject"
                  [assetDetails]="assetId"
                  [gridSettingsKeySuffix]="gridSettingsKeySuffix"
                  [viewType]="collectionViewType.asObservable()"
                  (collectionListToEmit)="handleCollectionList($event)"
                ></thehubz-collections-list>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-container>
      <ng-container *ngIf="combinedRelations.groupedAssetRelations as groups">
        <div *ngIf="groups.length && assetViewTypeService.getGridSettings('showListView', gridSettingsKeySuffix)" class="w-full" [ngClass]="showEmptyState ? '!h-[1px]' : 'h-[88%]'">
          <thehubz-asset-listview
            class="block h-full"
            *ngIf="(tableData$ | async)! as assets"
            [configObject]="configObject"
            [assetData]="assets"
            [tableColumnData]="relationsColumnDef"
            [assetUploadStepperFlag]="true"
            [assetCount]="assets.length"
            [gridSettingsKeySuffix]="gridSettingsKeySuffix"
            [tableType]="'relatedAssetsList'"
            (changeView)="changeAssetView($event)"
            (downloadAsset)="download($event.asset)"
          >
          </thehubz-asset-listview>
        </div>
        <div *ngIf="!combinedRelations.groupedAssetRelations.length && !combinedRelations.relatedCollections.length" class="pr-3 overflow-hidden mb-6">
          <p i18n>No relation types available</p>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
